import React from 'react';
import {
    Grid,
    TextField,
    FormControl,
    Select,
    MenuItem,
} from '@mui/material';
import { northAmericaCountries, CanadaProvinces, USAStates, MexicoStates } from '../../utils/dropOptions';

function AddressForm({ address, onChange, showDates = false }) {
    const getStateOptions = (country) => {
        switch (country) {
            case 'Canada':
                return CanadaProvinces;
            case 'U.S.A':
                return USAStates;
            case 'Mexico':
                return MexicoStates;
            default:
                return [];
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="Address Line 1"
                    value={address.line1}
                    onChange={(e) => onChange('line1', e.target.value)}
                    required
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="Address Line 2"
                    value={address.line2}
                    onChange={(e) => onChange('line2', e.target.value)}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    label="City"
                    value={address.city}
                    onChange={(e) => onChange('city', e.target.value)}
                    required
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth required>
                    <Select
                        value={address.country}
                        onChange={(e) => onChange('country', e.target.value)}
                        displayEmpty
                    >
                        <MenuItem value="" disabled>Select Country</MenuItem>
                        {northAmericaCountries.map((country) => (
                            <MenuItem key={country} value={country}>
                                {country}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth required>
                    <Select
                        value={address.stateProvince}
                        onChange={(e) => onChange('stateProvince', e.target.value)}
                        displayEmpty
                        disabled={!address.country}
                    >
                        <MenuItem value="" disabled>Select State/Province</MenuItem>
                        {getStateOptions(address.country).map((state) => (
                            <MenuItem key={state} value={state}>
                                {state}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    label="Postal Code"
                    value={address.postalCode}
                    onChange={(e) => onChange('postalCode', e.target.value)}
                    required
                />
            </Grid>
        </Grid>
    );
}

export default AddressForm;
